module.exports = __webpack_public_path__ + "img/face-smile-relaxed.d1ca4cd9.svg";